import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { PictureAsPdf, Description, InsertDriveFile } from '@mui/icons-material';

const FilePreview = ({ fileUrl }) => {
  if (!fileUrl || fileUrl === '-') return null;

  const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fileUrl);
  const isPdf = /\.pdf$/i.test(fileUrl);
  const isDoc = /\.(doc|docx)$/i.test(fileUrl);

  // Extract filename from URL
  const fileName = fileUrl.split('/').pop();
  // Get first 8 characters of the random part
  const shortName = fileName.substring(0, 8);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {isImage ? (
        <Link 
          href={fileUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: '#11998e',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          <img 
            src={fileUrl} 
            alt="Preview"
            style={{
              width: '40px',
              height: '40px',
              objectFit: 'cover',
              borderRadius: '4px'
            }}
          />
          <Typography variant="body2">{shortName}</Typography>
        </Link>
      ) : (
        <Link 
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: '#11998e',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          {isPdf ? (
            <PictureAsPdf sx={{ color: '#f44336' }} />
          ) : isDoc ? (
            <Description sx={{ color: '#2196f3' }} />
          ) : (
            <InsertDriveFile />
          )}
          <Typography variant="body2">{shortName}</Typography>
        </Link>
      )}
    </Box>
  );
};

export default FilePreview;